import React from "react"
import AdminList from "../components/AdminLIst/AdminList"
import { AdminContextProvider } from "../components/AdminLIst/AdminContext"

const AdminContainer = () => {
  return (
    <div>
      <AdminContextProvider>
        <AdminList />
      </AdminContextProvider>
    </div>
  )
}

export default AdminContainer
